import { styled } from '../../../../stitches.config'
import * as LabelPrimitive from '@radix-ui/react-label'
import * as SelectPrimitive from '@radix-ui/react-select'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const FieldWrapper = styled('div', {
    position: 'relative',
})

const StyledTrigger = styled(SelectPrimitive.SelectTrigger, {
    all: 'unset',
    display: 'flex',
    width: '93%',
    maxWidth: '81vw',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '2px solid $mediumGray',
    borderRadius: '$2',
    padding: '$1 $3',
    height: 35,
    fontSize: 15,
    lineHeight: 1,
    backgroundColor: 'white',
    color: '$dark',
    '&:focus': {
        borderColor: '$primary',
        '~ span': {
            color: '$primary',
        },
    },
})

const StyledContent = styled(SelectPrimitive.Content, {
    overflow: 'hidden',
    backgroundColor: 'white',
    borderRadius: 6,
    boxShadow:
        '0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2)',
})

const StyledViewport = styled(SelectPrimitive.Viewport, {
    padding: 5,
})

const StyledItem = styled(SelectPrimitive.Item, {
    all: 'unset',
    fontSize: '1rem',
    lineHeight: 1,
    color: '$dark',
    borderRadius: 3,
    display: 'flex',
    alignItems: 'center',
    height: 25,
    padding: '0 35px 0 25px',
    position: 'relative',
    userSelect: 'none',
    py: '$2',
    '@md': {
        py: '$1',
    },

    '&[data-disabled]': {
        color: '$light',
        pointerEvents: 'none',
    },

    '&:focus': {
        backgroundColor: '$primaryLight',
        color: '$primary',
    },
})

const StyledLabel = styled(SelectPrimitive.Label, {
    padding: '0 25px',
    fontSize: 12,
    lineHeight: '25px',
    color: '$primary',
})

const StyledSeparator = styled(SelectPrimitive.Separator, {
    height: 1,
    backgroundColor: '$primaryLight',
    margin: 5,
})

const StyledItemIndicator = styled(SelectPrimitive.ItemIndicator, {
    position: 'absolute',
    left: 0,
    width: 25,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
})

const scrollButtonStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 25,
    backgroundColor: 'white',
    color: '$primaryLight',
    cursor: 'default',
}

const StyledScrollUpButton = styled(
    SelectPrimitive.ScrollUpButton,
    scrollButtonStyles
)

const StyledScrollDownButton = styled(
    SelectPrimitive.ScrollDownButton,
    scrollButtonStyles
)

const StyledFieldLabel = styled(LabelPrimitive.Root, {
    userSelect: 'none',
    position: 'absolute',
    backgroundColor: 'white',
    color: '$dark',
    zIndex: 3,
    padding: '0 0.3em',
    fontSize: '0.75em',
    top: '-0.6em',
    left: '0.9em',
    // The following styles might later be used for moving the placeholder, like TextInputWithLabel does.
    // zIndex: -1,
    // padding: '0',
    // top: '1em',
    // left: '0.75em',
    // variants: {
    //     variant: {
    //         superscript: { ...labelMoved, color: '$dark' },
    //     },
    // },
})

// Exports
export const SelectWithLabel = SelectPrimitive.Root
export const SelectTrigger = StyledTrigger
export const SelectValue = SelectPrimitive.Value
export const SelectIcon = SelectPrimitive.Icon
export const SelectContent = StyledContent
export const SelectViewport = StyledViewport
export const SelectGroup = SelectPrimitive.Group
export const SelectItem = StyledItem
export const SelectItemText = SelectPrimitive.ItemText
export const SelectItemIndicator = StyledItemIndicator
export const SelectLabel = StyledLabel
export const SelectSeparator = StyledSeparator
export const SelectScrollUpButton = StyledScrollUpButton
export const SelectScrollDownButton = StyledScrollDownButton

export interface ISelectOption {
    label: string
    value: string
}

// TODO Set up TS interface

export const SelectInput = (props: any) => {
    const {
        initialError,
        initialTouched,
        initialValue,
        touched,
        numFormat,
        value,
        placeholder,
        options,
        defaultValue,
        emptyOptionLabel,
        ...theRest
    } = props
    return (
        <FieldWrapper>
            <SelectWithLabel
                id={'select' + props.name}
                defaultValue={defaultValue ?? 'empty'}
                {...theRest}
            >
                <SelectTrigger>
                    <SelectValue />
                    <SelectIcon style={{ marginLeft: '1em' }}>
                        <FontAwesomeIcon icon={faChevronDown} />
                    </SelectIcon>
                </SelectTrigger>
                <SelectContent>
                    <SelectViewport>
                        <SelectGroup>
                            {!defaultValue && (
                                <SelectItem
                                    value={'empty'}
                                    key={'emptyOptionLabel'}
                                >
                                    <SelectItemText>
                                        {emptyOptionLabel ?? '-'}
                                    </SelectItemText>
                                </SelectItem>
                            )}
                            {options.map((option: ISelectOption) => {
                                return (
                                    <SelectItem
                                        value={option.value}
                                        key={option.value}
                                    >
                                        <SelectItemText>
                                            {option.label}
                                        </SelectItemText>
                                    </SelectItem>
                                )
                            })}
                        </SelectGroup>
                    </SelectViewport>
                </SelectContent>
            </SelectWithLabel>
            <StyledFieldLabel
                htmlFor={'select' + props.name}
                css={{ marginRight: 15 }}
                // The following prop might later be used for moving the placeholder, like TextInputWithLabel does.
                // variant={value || placeholder ? 'superscript' : ''}
            >
                {props.label}
            </StyledFieldLabel>
        </FieldWrapper>
    )
}
